import type { SortEvent } from '@/core/types';
import { Colors } from '@/styles/colors';

interface Props {
  events: SortEvent[];
  currentEventIndex: number;
  isPlaying: boolean;
  onSeek: (pos: number) => void;
}

const EVENT_COLORS: Record<string, string> = {
  compare: '#ffd700',
  swap: '#ff6b6b',
  overwrite: '#4a90e2',
  mark: '#4a90e2',
  pivot: '#9b59b6',
  split: '#9b59b6',
  merge: '#00bcd4',
  heapify: '#e83e8c',
  bucket: '#17a2b8',
  gap: '#7952fb',
  runDetected: '#ffc107',
  modeSwitch: '#9b59b6',
  gallop: '#7952fb',
  msdPartition: '#9b59b6',
  done: '#50c878',
};

export function TimelineScrubber({ events, currentEventIndex, isPlaying, onSeek }: Props) {
  if (events.length === 0) return null;
  const pct = events.length > 1 ? currentEventIndex / (events.length - 1) : 0;

  return (
    <div style={{ padding: '12px 20px 16px', userSelect: 'none' }}>
      {/* progress bar */}
      <div
        style={{ position: 'relative', height: 20, cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        onClick={(e) => {
          const rect = e.currentTarget.getBoundingClientRect();
          const pos = Math.round(((e.clientX - rect.left) / rect.width) * (events.length - 1));
          onSeek(Math.max(0, Math.min(events.length - 1, pos)));
        }}
      >
        {/* track */}
        <div style={{ flex: 1, height: 4, backgroundColor: Colors.light.border, borderRadius: 2, position: 'relative', overflow: 'hidden' }}>
          {/* fill */}
          <div style={{ position: 'absolute', left: 0, top: 0, width: `${pct * 100}%`, height: '100%', backgroundColor: Colors.light.primary, borderRadius: 2, transition: 'width 0.1s' }} />
        </div>
        {/* thumb */}
        <div style={{
          position: 'absolute', left: `calc(${pct * 100}% - 6px)`, top: 5,
          width: 12, height: 12, borderRadius: '50%',
          backgroundColor: Colors.light.primary, border: `2px solid ${Colors.light.surface}`,
          transition: 'left 0.1s', pointerEvents: 'none',
        }} />
        <span style={{ marginLeft: 12, fontSize: 11, color: Colors.light.textSecondary, minWidth: 80, textAlign: 'right' }}>
          {isPlaying ? 'Berjalan' : 'Jeda'} - {currentEventIndex} / {events.length}
        </span>
      </div>
    </div>
  );
}
